import { Sector } from '@/models/sector'
import { BaseModel } from '@/models/base'

export class User extends BaseModel {
  constructor (
    public id: number,
    public proprietario?: string,
    public placa?: string,
    public renavam?: string,
    public modelo?: string,
    public cor?: string,
    public municipio?: String[],
    public functionalities?: String[],
    public roles?: Array<string>
  ) { super(id) }
}
